import { useEffect, useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import v2_actionConfigCrm from "src/actions/v2/crm/v2_actionConfigCrm";
import useAuth from "src/hooks/useAuth";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import v2_actionListaTagsChats from "src/actions/v2/chats/v2_actionListaTagsChats";
import { RowInput } from "src/components/forms/RowInput";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";
import Label from "src/components/Label";
import { Switch } from "src/@/components/ui/switch";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";

const CardChatTagInOut = ({
    actionPhase,
    actionState,
    changeActionState,
    users
}) => {
    const { cliente } = useAuth();
    const [tags, setTags] = useState([]);
    const [canais, setCanais] = useState([]);

    async function buscarListaTags() {
        try {
            const querys = `?cliente_id=${cliente._id}`;
            const response = await v2_actionListaTagsChats(querys);
            setTags(response.data.data);
        } catch (error) {
            console.error("Erro ao buscar lista de tags:", error);
        }
    }

    async function buscarListaCanais() {
        try {
            const response = await actionListaCanaisPorCliente(cliente._id);
            setCanais(response.data.data || []);
        } catch (error) {
            console.error("Erro ao buscar lista de canais:", error);
        }
    }

    let canaisFormatted = canais?.map((canal) => {
        return {
            value: canal.cliente_id || canal.clienteId,
            label: canal.nome
        }
    });

    useEffect(() => {
        buscarListaTags();
        buscarListaCanais();
    }, []);

    const listFormat = tags.map((tag) => ({
        value: tag._id,
        label: tag.nome,
    }));



    return (
        <Card className="w-full">
            <CardHeader>
                <LabelFromAction>
                    {actionPhase.name}
                </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="space-y-4 flex flex-col gap-4">
                    <RowInput
                        isRequired={true}
                        label="Canal"
                        info={"Canais que estão atrelados ao chat"}
                        input={
                            <MultiSelect
                                options={canaisFormatted}
                                onValueChange={(e) =>
                                    changeActionState({ name: "chatChannels", value: e })
                                }
                                defaultValue={actionState.chatChannels}
                                placeholder="Selecionar canais"
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <RowInput
                        required={true}
                        label="Ação"
                        input={<RadioGroup
                            className="flex flex-row"
                            defaultValue={actionState?.actionTag}
                            onValueChange={(e) => changeActionState({ name: "actionTag", value: e })}
                        >
                            <div className="flex items-center space-x-2">
                                <RadioGroupItem value="add" id="add" />
                                <Label htmlFor="add">Tag adicionada</Label>
                            </div>
                            <div className="flex items-center space-x-2">
                                <RadioGroupItem value="remove" id="remove" />
                                <Label htmlFor="remove">Tag removida</Label>
                            </div>
                        </RadioGroup>}
                    />

                    {actionState?.actionTag && (
                        <div className="flex flex-col gap-2">
                            <RowInput
                                required={true}
                                label="Adicionar tags"
                                input={<MultiSelect
                                    options={listFormat}
                                    onValueChange={(selectedValues) => {
                                        changeActionState({ name: "tags", value: selectedValues })
                                    }}
                                    defaultValue={actionState.tags} // Usa o estado local
                                    placeholder="Selecionar tags"
                                    variant="inverted"
                                    animation={2}
                                    maxCount={3}
                                />}
                            />
                            <RowInput
                                label="Usuários"
                                input={<MultiSelect
                                    options={users}
                                    onValueChange={(e) => {
                                        console.log(e);
                                        let event = {
                                            name: "chatUsersAssign",
                                            value: e
                                        }
                                        changeActionState(event);
                                    }}
                                    defaultValue={actionState?.chatUsersAssign}
                                    placeholder="Selecionar usuarios"
                                    variant="inverted"
                                    animation={2}
                                    maxCount={3}
                                />}
                            />
                        </div>
                    )}


                    <AutomationOnlyExecute
                        actionState={actionState}
                        changeActionState={changeActionState}
                    />




                </div>
            </CardContent>
        </Card>
    );
};

export default CardChatTagInOut;
